import { InjectionToken } from '@angular/core';

export interface IIqTrackingStateService {}

export const TRACKING_SEGMENT_KEY = new InjectionToken<string>(
    'Tracking Segment  Key',
    {
        providedIn: 'root',
        factory: () => '',
    },
);

export const OBSERVE_SERVICE_NAME = new InjectionToken<string>(
    'Observe Service Name',
    {
        providedIn: 'root',
        factory: () => '',
    },
);
export const OBSERVE_SERVICE_VERSION = new InjectionToken<string>(
    'Observe Service Version',
    {
        providedIn: 'root',
        factory: () => '',
    },
);
export const OTEL_ENDPOINT = new InjectionToken<string>(
    'Otel End Point',
    {
        providedIn: 'root',
        factory: () => '',
    },
);
export const OTEL_HEADERS = new InjectionToken<{ Authorization: string }>(
    'Otel Headers',
    {
        providedIn: 'root',
        factory: () => ({
            Authorization: '',
        }),
    },
);
